import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
	PiPaperPlaneTilt,
	PiCheckCircleFill,
	PiCaretRightBold,
	PiCalendarBlank,
} from "react-icons/pi";
import SimulationTypeStep from "./steps/simulation-type-step";
import AttackVectorStep from "./steps/attack-vector-step";
import CampaignDetailsStep from "./steps/campaign-details-step";
import TemplateSelectionStep from "./steps/template-selection-step";
import TrainingSelectionStep from "./steps/training-selection-step";
import PreviewStep from "./steps/preview-step";
import CampaignPreview from "../create-template/campaign-preview/campaign-preview";
import axios from "../../axios";
import axiosLib from "axios";
import apiError from "../../error";
import { setCookie } from "../../function";
import Loader from "../loader/loader";
import simulationattack from "../../assets/create_campaign/simulationattack.png";
import simulationandtraining from "../../assets/create_campaign/simulationandtrain.png";
import vishing from "../../assets/create_campaign/vishing.png";
import whatsapp from "../../assets/create_campaign/whatsapp.png";
import smishing from "../../assets/create_campaign/smishing.png";
import phishing from "../../assets/create_campaign/emailPhishing.png";
import cyberScam from "../../assets/create_campaign/cyberscam.png";
import Attachment from "../../assets/create_campaign/attachment.png";
import ransomeware from "../../assets/create_campaign/ransomware.png";
import QRcode from "../../assets/create_campaign/qrcode.png";
import removalMedia from "../../assets/create_campaign/removablemedia.png";
import telegram from "../../assets/create_campaign/telegram.png";
import aiVishing from "../../assets/create_campaign/aivishing.png";
import runImm from "../../assets/create_campaign/runImm.png";
import runSchedule from "../../assets/create_campaign/runSchedule.png";
import runtest from "../../assets/create_campaign/runtest.png";
import "./launch-new-modal.css";
import { featuresObj } from "../../globalData";
import { resolveAwarenessTargetedGroupForInstantOn } from "./awareness-defaults";
import { isSimulationTypeAllowed } from "./simulation-compatibility";

const CampaignScheduleDateInput = React.forwardRef(
	({ value, onClick, onChange, onFocus }, ref) => (
		<button
			type="button"
			className="campaign-run-mode-datepicker-trigger"
			onClick={onClick}
			onFocus={onFocus}
			ref={ref}
		>
			<span className="campaign-run-mode-datepicker-trigger__icon" aria-hidden="true">
				<PiCalendarBlank />
			</span>
			<input
				type="text"
				className="campaign-run-mode-datepicker-trigger__field"
				value={value}
				onChange={onChange}
				onClick={onClick}
				onFocus={onFocus}
				placeholder="DD/MM/YYYY / hh:mm"
				readOnly
			/>
		</button>
	)
);
CampaignScheduleDateInput.displayName = "CampaignScheduleDateInput";

function createDefaultCampaignDetails() {
	return {
		campaignName: "",
		targetGroups: [],
		instantAwareness: false,
		userReply: true,
		credentialHarvesting: false,
		expiryDays: 7,
		customExpiryDate: null,
		awarenessTargetedGroup: "",
		timeFrame: "1",
		isRepliedCampaign: false,
		targetInteractionType: "",
		isAIbased: false
	};
}

const STEP_IMAGES_PRELOAD = [
	simulationattack,
	simulationandtraining,
	vishing,
	whatsapp,
	smishing,
	phishing,
	cyberScam,
	Attachment,
	ransomeware,
	QRcode,
	removalMedia,
	telegram,
	aiVishing,
	runImm,
	runSchedule,
	runtest
];

class LaunchNewModal extends Component {
	constructor(props) {
		super(props);
		// Step refs keyed by step key (steps are dynamic: training only appears
		// for "Simulation Attack + Training").
		this.stepRefs = {};
		this.state = this.buildResetState(null);
		this._isMounted = false;
		this.requestCancel = null;
	}

	componentDidMount() {
		this._isMounted = true;
	}

	componentWillUnmount() {
		this._isMounted = false;
		if (this.requestCancel) this.requestCancel();
	}

	componentDidUpdate(prevProps, prevState) {
		if (!prevProps.showModal && this.props.showModal) {
			this.preloadStepImages();
			this.setState(
				this.buildResetState({
					// The campaign type remains selectable, while the source template's
					// attack vector and template selection stay locked.
					simulationType: "",
					attackType: this.props.attackType,
					categoryId: this.props.categoryId,
					templateSelectedCategory: this.props.templateSelectedCategory,
					campaignTemplateId: this.props.campaignTemplateId,
					targetInteractionType: this.props.targetInteractionType,
					isAIbased: this.props.isAIbased
				})
			);
		}
		// Update userReplyFeature when package is fetched
		if (this.props.isPackageFetched !== prevProps.isPackageFetched && this.props.isPackageFetched) {
			this.setState({ userReplyFeature: featuresObj['reply-tracking-over-phishing'] });
		}
		// Default mode-based vectors only when entering them from another attack; do not overwrite inbound/outbound the user already set.
		if (prevState.attackType !== this.state.attackType && !this.props.prefilledFromTemplate) {
			if ((this.state.attackType === "Vishing" || this.state.attackType === "WhatsApp") && prevState.attackType !== this.state.attackType) {
				this.setState((prev) => {
					const raw = prev.campaignDetails?.targetInteractionType;
					const hasExplicit =
						raw !== undefined && raw !== null && String(raw).trim() !== "";
					if (hasExplicit) return null;
					return {
						campaignDetails: {
							...prev.campaignDetails,
							targetInteractionType: "outbound",
							isAIbased: prev.campaignDetails?.isAIbased ?? false
						}
					};
				});
			}
		}
	}

	preloadStepImages = () => {
		STEP_IMAGES_PRELOAD.forEach((src) => {
			const img = new Image();
			img.src = src;
		});
	}

	buildResetState(prefill) {
		const cd = createDefaultCampaignDetails();
		if (prefill) {
			const titRaw = prefill.targetInteractionType;
			const hasTit = titRaw != null && String(titRaw).trim() !== "";
			const explicitAi = prefill.isAIbased === true || prefill.isAIbased === false;
			// Prefer explicit isAIbased from template preview over targetInteractionType so stale "inbound"
			// defaults cannot force AI when the template is IVR (outbound).
			if (explicitAi) {
				cd.isAIbased = prefill.isAIbased;
				cd.targetInteractionType = prefill.isAIbased ? "inbound" : "outbound";
			} else if (hasTit) {
				cd.targetInteractionType = titRaw;
				const t = String(titRaw).trim().toLowerCase();
				if (t === "inbound") cd.isAIbased = true;
				else if (t === "outbound") cd.isAIbased = false;
			}
		}
		const simulationType = (prefill && prefill.simulationType) || "";
		const attackType = (prefill && prefill.attackType) || "";
		cd.awarenessTargetedGroup = resolveAwarenessTargetedGroupForInstantOn(
			simulationType,
			attackType,
			cd.instantAwareness,
			cd.awarenessTargetedGroup
		);
		let templateId = null;
		if (prefill && prefill.campaignTemplateId != null && prefill.campaignTemplateId !== "") {
			const tid = typeof prefill.campaignTemplateId === "number" ? prefill.campaignTemplateId : parseInt(prefill.campaignTemplateId, 10);
			if (!Number.isNaN(tid)) templateId = tid;
		}
		let templateSelectedCategory = "";
		let templateSelectedCategoryIds = [];
		if (prefill) {
			if (Array.isArray(prefill.templateSelectedCategoryIds) && prefill.templateSelectedCategoryIds.length > 0) {
				templateSelectedCategoryIds = [...prefill.templateSelectedCategoryIds];
				templateSelectedCategory = templateSelectedCategoryIds[0];
			} else if (prefill.templateSelectedCategory != null && prefill.templateSelectedCategory !== "") {
				templateSelectedCategory = prefill.templateSelectedCategory;
				templateSelectedCategoryIds = [prefill.templateSelectedCategory];
			} else if (prefill.categoryId != null && prefill.categoryId !== "") {
				templateSelectedCategory = prefill.categoryId;
				templateSelectedCategoryIds = [prefill.categoryId];
			}
		}
		return {
			currentStep: 1,
			highestStepReached: 1,
			progress: 0,
			simulationType: (prefill && prefill.simulationType) || "",
			attackType: (prefill && prefill.attackType) || "",
			campaignDetails: cd,
			templateId,
			templateSelectedCategory,
			templateSelectedCategoryIds,
			templateSelectionMode: "single",
			// "My Templates" run directly; "System Templates" are cloned before running/testing.
			templateType: (prefill && prefill.templateType) || "My Templates",
			selectedTemplateIds: [],
			selectedTemplates: [],
			training: {
				trainingAssignmentMode: "single",
				selectedCourses: [],
				selectedOptions: {},
				courseName: {},
				imageURL: "",
				sendCourseTemplateId: null,
				courseCompletionTemplateId: null,
				courseQuizFailReminderTemplateId: null,
				sendQuizTemplateId: null
			},
			previewData: {},
			showTemplateDetailsModal: false,
			previewTemplateId: null,
			showRunModeModal: false,
			runMode: "immediately",
			scheduledDate: null,
			loading: false,
			userReplyFeature: featuresObj["reply-tracking-over-phishing"]
		};
	}

	resetModal = () => {
		this.setState(this.buildResetState(null));
	}

	/* ---- Dynamic step model ----
	   Training Selection only appears for "Simulation Attack + Training".
	   Steps are identified by key so numbering can shift safely. */
	hasTrainingStep = () => this.state.simulationType === "Simulation Attack + Training";

	getStepKeys = () => {
		const keys = ["simulationType", "attackVector", "campaignDetails", "templateSelection"];
		if (this.hasTrainingStep()) keys.push("trainingSelection");
		keys.push("preview");
		return keys;
	}

	getTotalSteps = () => this.getStepKeys().length;

	getStepKey = (stepNumber) => this.getStepKeys()[stepNumber - 1];

	getStepNumber = (key) => this.getStepKeys().indexOf(key) + 1;

	makeid = () => {
		let result = "";
		const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
		for (let i = 0; i < 30; i++) {
			result += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		return result;
	};

	calculateCampaignExpiry = (scheduledAt) => {
		const scheduledDate = new Date(scheduledAt);
		const cd = this.state.campaignDetails;
		const expiryDays = cd?.expiryDays;
		const customExpiryDate = cd?.customExpiryDate;
		if (expiryDays === 7) {
			const expiryDate = new Date(scheduledDate);
			expiryDate.setDate(expiryDate.getDate() + 7);
			return expiryDate.toISOString();
		}
		if (expiryDays === 15) {
			const expiryDate = new Date(scheduledDate);
			expiryDate.setDate(expiryDate.getDate() + 15);
			return expiryDate.toISOString();
		}
		if (expiryDays === "custom" && customExpiryDate) {
			const expiryDate = new Date(customExpiryDate);
			return isNaN(expiryDate.getTime()) ? null : expiryDate.toISOString();
		}
		return null;
	};

	buildPayload = (scheduledAt, campaignType) => {
		const cd = this.state.campaignDetails;
		const groupIds = (cd?.targetGroups || []).map((t) => t.value);
		const single = this.state.templateSelectionMode === "single";
		const random = !single;
		const campaignTemplateId = single ? (this.state.templateId || null) : null;
		const campaignTemplateIds = single ? [] : (this.state.selectedTemplateIds || []);
		// Training Selection payload — only for Simulation + Training campaigns
		// with at least one selected course.
		let training = undefined;
		if (this.hasTrainingStep()) {
			const t = this.state.training || {};
			const selectedOptions = {};
			(t.selectedCourses || []).forEach((courseId) => {
				selectedOptions[courseId] = (t.selectedOptions && t.selectedOptions[courseId]) || {};
			});
			if (Object.keys(selectedOptions).length > 0) {
				training = {
					trainingAssignmentMode: t.trainingAssignmentMode || "single",
					selectedOptions,
					sendCourseTemplateId: t.sendCourseTemplateId || null,
					courseCompletionTemplateId: t.courseCompletionTemplateId || null,
					courseQuizFailReminderTemplateId: t.courseQuizFailReminderTemplateId || null,
					sendQuizTemplateId: t.sendQuizTemplateId || null
				};
			}
		}
		return {
			// type: "My Templates",
			single,
			random,
			scheduledAt: scheduledAt instanceof Date ? scheduledAt : new Date(scheduledAt),
			groupIds,
			category: this.state.templateSelectedCategory || "",
			frequency: "One Time",
			identifier: this.makeid(),
			campaignName: (cd?.campaignName || "").trim(),
			simulationType: this.state.simulationType,
			campaignTemplateId,
			campaignTemplateIds,
			attackType: this.state.attackType,
			credentialHarvesting: this.state.campaignDetails?.credentialHarvesting,
			// period: "1",
			simulationId: 0,
			simulationState: null,
			sendCampaignOnOldSimulation: false,
			// lmsDelay: new Date(new Date().setMinutes(new Date().getMinutes() + 300)),
			lmsMsgStatus: cd?.awarenessTargetedGroup || "",
			isRepliedCampaign: cd?.isRepliedCampaign === true,
			isInstantAwareness:
				this.state.simulationType === "Simulation Attack"
					? false
					: cd?.instantAwareness === true,
			campaignExpiry: this.calculateCampaignExpiry(scheduledAt),
			campaignType,
			delay: cd?.timeFrame || "1",
			...(training ? { training } : {})
		};
	};

	updateProgress = () => {
		// Progress increases only when Continue is clicked: step 1 = 0%, 2 = 20%, 3 = 40%, 4 = 60%, 5 = 100%
		if (this.state.showRunModeModal) {
			this.setState({ progress: 100 });
			return;
		}
		const { currentStep } = this.state;
		const total = this.getTotalSteps();
		const progress = currentStep >= total ? 100 : Math.round(((currentStep - 1) / total) * 100);
		this.setState({ progress });
	}

	handleStepChange = (step) => {
		if (step < 1 || step > this.getTotalSteps()) return;
		if (step > this.state.highestStepReached) return;
		// When clicking a step ahead, validate all steps from 1 up to (but not including) the target step
		if (step > this.state.currentStep) {
			for (let s = 1; s < step; s++) {
				if (!this.validateStep(s)) return;
			}
		}
		this.setState({ currentStep: step }, () => {
			this.updateProgress();
		});
	}

	validateStep = (stepNum) => {
		const key = this.getStepKey(stepNum);
		const templateStepNumber = this.getStepNumber("templateSelection");
		switch (key) {
			case "simulationType":
				if (!this.state.simulationType) {
					if (this.stepRefs.simulationType && this.stepRefs.simulationType.validate) {
						this.stepRefs.simulationType.validate();
					}
					return false;
				}
				if (!isSimulationTypeAllowed(this.state.attackType, this.state.simulationType)) {
					toast.error(`${this.state.simulationType} is not available for ${this.state.attackType} campaigns`);
					return false;
				}
				return true;
			case "attackVector":
				if (!this.state.attackType) {
					if (this.stepRefs.attackVector && this.stepRefs.attackVector.validate) {
						this.stepRefs.attackVector.validate();
					}
					return false;
				}
				return true;
			case "campaignDetails": {
				if (this.stepRefs.campaignDetails && this.stepRefs.campaignDetails.validate) {
					return this.stepRefs.campaignDetails.validate();
				}
				// Not mounted; use parent state
				const cd = this.state.campaignDetails || {};
				const hasName = cd.campaignName && String(cd.campaignName).trim().length > 0;
				const hasGroups = cd.targetGroups && cd.targetGroups.length > 0;
				const hasCustomExpiry = cd.expiryDays !== "custom" || !!(cd.customExpiryDate && String(cd.customExpiryDate).trim().length > 0);
				const instantAw = cd.instantAwareness === true;
				const resolvedAwareness = resolveAwarenessTargetedGroupForInstantOn(
					this.state.simulationType,
					this.state.attackType,
					instantAw,
					cd.awarenessTargetedGroup
				);
				const needsAwarenessGroup =
					this.state.simulationType === "Simulation Attack + Training";
				const hasAwarenessTargetedGroup =
					!needsAwarenessGroup ||
					!!(resolvedAwareness && String(resolvedAwareness).trim().length > 0);
				return !!hasName && !!hasGroups && hasCustomExpiry && hasAwarenessTargetedGroup;
			}
			case "templateSelection": {
				const mode = this.state.templateSelectionMode || "single";
				const parentHasSingle = (this.state.templateId != null && this.state.templateId !== "");
				const parentHasMultiple = !!(this.state.selectedTemplateIds && this.state.selectedTemplateIds.length > 1);
				const parentValid = mode === "single" ? parentHasSingle : parentHasMultiple;

				if (this.state.currentStep === templateStepNumber) {
					if (this.stepRefs.templateSelection && typeof this.stepRefs.templateSelection.validate === "function") {
						if (this.stepRefs.templateSelection.validate()) return true;
					} else if (!parentValid) {
						toast.error(mode === "random" ? "Please select at least two templates" : "Please select a template");
					}
					if (parentValid) return true;
					return false;
				}
				return parentValid;
			}
			case "trainingSelection": {
				if (this.stepRefs.trainingSelection && typeof this.stepRefs.trainingSelection.validate === "function") {
					return this.stepRefs.trainingSelection.validate();
				}
				// Not mounted; validate from parent state
				const t = this.state.training || {};
				if (!t.selectedCourses || t.selectedCourses.length === 0) {
					toast.error("Please select at least one training course");
					return false;
				}
				return true;
			}
			case "preview":
				return true;
			default:
				return false;
		}
	}

	validateCurrentStep = () => {
		return this.validateStep(this.state.currentStep);
	}

	isCampaignDetailsContinueEnabled = () => {
		const cd = this.state.campaignDetails || {};
		const hasName = cd.campaignName && String(cd.campaignName).trim().length > 0;
		const hasGroups = cd.targetGroups && cd.targetGroups.length > 0;
		const hasCustomExpiry = cd.expiryDays !== "custom" || !!(cd.customExpiryDate && String(cd.customExpiryDate).trim().length > 0);
		const instantAw = cd.instantAwareness === true;
		const resolvedAwareness = resolveAwarenessTargetedGroupForInstantOn(
			this.state.simulationType,
			this.state.attackType,
			instantAw,
			cd.awarenessTargetedGroup
		);
		const needsAwarenessGroup =
			this.state.simulationType === "Simulation Attack + Training";
		const hasAwarenessTargetedGroup =
			!needsAwarenessGroup ||
			!!(resolvedAwareness && String(resolvedAwareness).trim().length > 0);
		return !!hasName && !!hasGroups && hasCustomExpiry && hasAwarenessTargetedGroup;
	}

	isTemplateContinueEnabled = () => {
		const mode = this.state.templateSelectionMode || "single";
		if (mode === "single") {
			return this.state.templateId != null && this.state.templateId !== "";
		}
		return Array.isArray(this.state.selectedTemplateIds) && this.state.selectedTemplateIds.length > 1;
	}

	isTrainingContinueEnabled = () => {
		const training = this.state.training || {};
		const mode = training.trainingAssignmentMode || "single";
		const selectedCourses = Array.isArray(training.selectedCourses) ? training.selectedCourses : [];
		if (mode === "single") {
			return selectedCourses.length >= 1;
		}
		return selectedCourses.length > 1;
	}

	handleNext = () => {
		const currentKey = this.getStepKey(this.state.currentStep);
		// Flush the mounted step's selection to parent so downstream steps see it
		if (currentKey === "templateSelection" && this.stepRefs.templateSelection && typeof this.stepRefs.templateSelection.updateData === "function") {
			this.stepRefs.templateSelection.updateData();
		}
		if (currentKey === "trainingSelection" && this.stepRefs.trainingSelection && typeof this.stepRefs.trainingSelection.pushUpdate === "function") {
			this.stepRefs.trainingSelection.pushUpdate();
		}
		if (this.validateCurrentStep()) {
			if (this.state.currentStep < this.getTotalSteps()) {
				const nextStep = this.state.currentStep + 1;
				this.setState(
					{ currentStep: nextStep, highestStepReached: Math.max(this.state.highestStepReached, nextStep) },
					() => this.updateProgress()
				);
			} else {
				this.setState({ showRunModeModal: true }, () => this.updateProgress());
			}
		}
	}

	handleRunModeCancel = () => {
		this.setState({ showRunModeModal: false, scheduledDate: null }, () => this.updateProgress());
	};

	getScheduledAt = () => {
		if (this.state.runMode === "schedule") {
			const sd = this.state.scheduledDate;
			if (sd && new Date(sd) > new Date()) return sd instanceof Date ? sd : new Date(sd);
			return null;
		}
		return new Date();
	};

	handleRunModeSubmit = () => {
		const runMode = this.state.runMode;
		const campaignDetails = this.state.campaignDetails || {};
		const scheduledAt = this.getScheduledAt();
		if (runMode === "schedule") {
			if (!scheduledAt || new Date(scheduledAt) <= new Date()) {
				toast.error("Please select a date and time in the future");
				return;
			}
		}
		const campaignType = runMode === "test" ? "test" : "live";
		const data = this.buildPayload(scheduledAt, campaignType);
		if (!data.groupIds || data.groupIds.length === 0) {
			toast.error("Please select at least one target group");
			return;
		}
		if (!data.campaignName || data.campaignName.length === 0) {
			toast.error("Please enter campaign name");
			return;
		}
		if (!data.campaignTemplateId && (!data.campaignTemplateIds || data.campaignTemplateIds.length === 0)) {
			toast.error("Please select a template");
			return;
		}

		if (campaignDetails.expiryDays === "custom" && !data.campaignExpiry) {
			toast.error("Please Select Campaign Expiry Date for Custom Option");
			return;
		}

		if (
			data.simulationType === "Simulation Attack + Training" &&
			data.isInstantAwareness &&
			!data.lmsMsgStatus
		) {
			toast.error("Please Select Awareness Targeted Group");
			return;
		}
		this.setState({ showRunModeModal: false, scheduledDate: null, loading: true }, () => {
			if (this.state.templateType === "System Templates") {
				this.cloneSystemTemplatesThenSend(data);
			} else {
				this.checkExistingGroupsThenSend(data);
			}
		});
	};

	/**
	 * System templates can't be run directly — clone each selected one first, then run the campaign
	 * against the clones. If any clone comes back as a draft, stop and prompt the user to review/save it.
	 */
	cloneSystemTemplatesThenSend = (data) => {
		const single = this.state.templateSelectionMode === "single";
		const sourceIds = single
			? (this.state.templateId != null ? [this.state.templateId] : [])
			: (this.state.selectedTemplateIds || []);
		if (!sourceIds.length) {
			this.setState({ loading: false });
			toast.error("Please select a template");
			return;
		}
		Promise.all(
			sourceIds.map((id) =>
				axios.post("/api/store/clone-campaign-template/" + id, {}).then((res) => ({
					clonedId: res.data.campaignTemplateId != null ? res.data.campaignTemplateId : res.data.response?.id,
					status: res.data.status
				}))
			)
		)
			.then((results) => {
				const clonedIds = results.map((r) => r.clonedId).filter((v) => v != null);
				if (clonedIds.length !== sourceIds.length) {
					this.setState({ loading: false });
					toast.error("Failed to clone the selected system template");
					return;
				}
				const draft = results.find((r) => (r.status || "").toLowerCase() === "draft");
				if (draft) {
					this.setState({ loading: false });
					this.showClonedDraftAlert(draft.clonedId);
					return;
				}
				// All clones are saved/completed — run the campaign against the cloned templates.
				const clonedData = {
					...data,
					campaignTemplateId: single ? clonedIds[0] : null,
					campaignTemplateIds: single ? [] : clonedIds
				};
				this.checkExistingGroupsThenSend(clonedData);
			})
			.catch((err) => {
				if (this._isMounted) this.setState({ loading: false });
				apiError(err);
			});
	};

	/** Draft clone can't be run: tell the user and offer to open its preview page to review & save. */
	showClonedDraftAlert = (clonedTemplateId) => {
		swal({
			title: "Template Cloned",
			text: "This system template has been cloned to your templates, but it is still a draft. Please review and save the cloned template before running the campaign.",
			icon: "info",
			buttons: { proceed: { text: "Proceed", value: true, className: "btn-custom-info" } },
			closeOnClickOutside: false
		}).then((proceed) => {
			if (proceed && clonedTemplateId != null) {
				this.props.showHandle();
				if (this.props.history) {
					this.props.history.push("/templates/" + clonedTemplateId + "?preview=1");
				} else if (this.props.nextPath) {
					this.props.nextPath("/templates/" + clonedTemplateId + "?preview=1");
				}
			}
		});
	};

	checkExistingGroupsThenSend = (data) => {
		const source = axiosLib.CancelToken && axiosLib.CancelToken.source();
		if (source) this.requestCancel = source.cancel;
		axios
			.post("/api/groups/alreadyExistsTargetInGroups", { groupIds: data.groupIds }, { cancelToken: source ? source.token : undefined })
			.then((res) => {
				if (!this._isMounted) return;
				if (res.data.success) {
					this.setState({ loading: false });
					const content = document.createElement("div");
					content.innerHTML = res.data.group_targets[0].email;
					content.innerHTML += res.data.group_targets.length > 1 ? `....   and ${res.data.group_targets.length - 1} other Emails<br>` : "<br>";
					content.innerHTML += "Still if you want to run campaign click on Yes otherwise No.";
					swal({
						title: "User exists in multiple groups",
						html: true,
						icon: "warning",
						content: content,
						buttons: ["No", "Yes"]
					}).then((willSuccess) => {
						if (willSuccess && this._isMounted) {
							this.setState({ loading: true });
							this.sendCampaign(data);
						} else if (this._isMounted) {
							this.setState({ loading: false });
						}
					});
				} else {
					this.sendCampaign(data);
				}
			})
			.catch((err) => {
				if (axiosLib.isCancel && axiosLib.isCancel(err)) return;
				if (this._isMounted) this.setState({ loading: false });
				apiError(err);
			});
	};

	sendCampaign = (data) => {
		const source = axiosLib.CancelToken && axiosLib.CancelToken.source();
		if (source) this.requestCancel = source.cancel;
		axios
			.post("/api/simulation/", data, { cancelToken: source ? source.token : undefined })
			.then((res) => {
				if (!this._isMounted) return;
				this.setState({ loading: false });
				setCookie("isDashboard", true, 30000);
				toast.success(data.campaignType === "test" ? "Test Campaign Run Successfully" : "Campaign Run Successfully");
				this.props.showHandle();
				/** New campaigns often return health 0 from the API; header should show full (100%) until list/API matches. Same pattern as `campaignListHealth` from campaign list. */
				const newCampaignPageState = { campaignListHealth: 100 };
				const navigateAfterCreate = (pathWithQuery) => {
					if (this.props.history) {
						const q = pathWithQuery.indexOf("?");
						const pathname = q >= 0 ? pathWithQuery.slice(0, q) : pathWithQuery;
						const search = q >= 0 ? pathWithQuery.slice(q) : "";
						this.props.history.push({ pathname, search, state: newCampaignPageState });
					} else if (this.props.nextPath) {
						this.props.nextPath(pathWithQuery);
					}
				};
				if (res.data && (this.props.history || this.props.nextPath)) {
					if (data.campaignType === "test") {
						const campId = res.data.campaignId;
						const rawSimId = res.data.simulationId ?? res.data.simulation?.id;
						const simId =
							rawSimId != null && String(rawSimId).trim() !== "" ? rawSimId : null;
						const testEditPath =
							campId && simId != null && simId !== ""
								? `/campaign/${campId}/${simId}?from=test-campaign`
								: campId
									? `/campaign/${campId}?from=test-campaign`
									: null;
						if (testEditPath) {
							setTimeout(() => navigateAfterCreate(testEditPath), 500);
						}
					} else if (res.data.campaignId) {
						const campId = res.data.campaignId;
						setTimeout(() => {
							if (this.props.history) {
								this.props.history.push({ pathname: `/campaign/${campId}`, state: newCampaignPageState });
							} else if (this.props.nextPath) {
								this.props.nextPath("/campaign/" + campId);
							}
						}, 500);
					}
				}
			})
			.catch((err) => {
				if (axiosLib.isCancel && axiosLib.isCancel(err)) return;
				if (this._isMounted) this.setState({ loading: false });
				apiError(err);
			});
	};

	handleBack = () => {
		if (this.state.currentStep > 1) {
			this.handleStepChange(this.state.currentStep - 1);
		}
	}

	// State update handlers for each step
	updateSimulationType = (simulationType) => {
		if (!isSimulationTypeAllowed(this.state.attackType, simulationType)) {
			toast.error(`${simulationType} is not available for ${this.state.attackType} campaigns`);
			return;
		}
		// Start unchecked; user enables Instant Awareness on the campaign details step if needed.
		const instantAwareness = false;
		this.setState(
			(prev) => {
				const nextCd = { ...prev.campaignDetails, instantAwareness };
				nextCd.awarenessTargetedGroup = resolveAwarenessTargetedGroupForInstantOn(
					simulationType,
					prev.attackType,
					instantAwareness,
					nextCd.awarenessTargetedGroup
				);
				return { simulationType, campaignDetails: nextCd };
			},
			() => this.updateProgress()
		);
	}

	updateAttackVector = (data) => {
		const nextCH = data.credentialHarvesting !== undefined ? data.credentialHarvesting : this.state.campaignDetails?.credentialHarvesting;
		const credentialHarvestingChanged = nextCH !== this.state.campaignDetails?.credentialHarvesting;
		const nextAttack = data.attackType || this.state.attackType;
		const prevAttack = this.state.attackType;
		const nextCd = { ...this.state.campaignDetails, credentialHarvesting: nextCH };
		nextCd.awarenessTargetedGroup = resolveAwarenessTargetedGroupForInstantOn(
			this.state.simulationType,
			nextAttack,
			nextCd.instantAwareness,
			nextCd.awarenessTargetedGroup
		);
		if ((nextAttack === "Vishing" || nextAttack === "WhatsApp") && prevAttack !== nextAttack) {
			const tit = nextCd.targetInteractionType;
			if (tit === undefined || tit === null || String(tit).trim() === "") {
				nextCd.targetInteractionType = "outbound";
				nextCd.isAIbased = false;
			}
		}
		this.setState({
			attackType: nextAttack,
			campaignDetails: nextCd,
			// Clear template selection when credential harvesting changes so preview only shows templates for current setting
			...((credentialHarvestingChanged && !this.props.prefilledFromTemplate) ? { templateId: null, selectedTemplateIds: [], selectedTemplates: [] } : {})
		}, () => {
			this.updateProgress();
		});
	}

	updateCampaignDetails = (data) => {
		const nextDetails = { ...this.state.campaignDetails, ...data };
		const credentialHarvestingChanged = data.hasOwnProperty("credentialHarvesting") && nextDetails.credentialHarvesting !== this.state.campaignDetails.credentialHarvesting;
		this.setState({
			campaignDetails: nextDetails,
			// Clear template selection when credential harvesting changes so preview only shows templates for current setting
			...((credentialHarvestingChanged && !this.props.prefilledFromTemplate) ? { templateId: null, selectedTemplateIds: [], selectedTemplates: [] } : {})
		}, () => {
			this.updateProgress();
		});
	}

	updateTemplateSelection = (payload) => {
		if (typeof payload === "object" && payload !== null) {
			const nextTemplates =
				payload.hasOwnProperty("selectedTemplates") && Array.isArray(payload.selectedTemplates)
					? payload.selectedTemplates
					: this.state.selectedTemplates;
			let templateId = payload.hasOwnProperty("templateId") ? payload.templateId : this.state.templateId;
			let selectedTemplateIds = payload.hasOwnProperty("selectedTemplateIds")
				? payload.selectedTemplateIds || []
				: this.state.selectedTemplateIds;
			if (Array.isArray(nextTemplates) && nextTemplates.length === 0) {
				templateId = null;
				selectedTemplateIds = [];
			}

			let templateSelectedCategory = this.state.templateSelectedCategory;
			let templateSelectedCategoryIds = this.state.templateSelectedCategoryIds || [];
			if (payload.hasOwnProperty("selectedCategoryIds") && Array.isArray(payload.selectedCategoryIds)) {
				templateSelectedCategoryIds = [...payload.selectedCategoryIds];
				templateSelectedCategory =
					templateSelectedCategoryIds.length > 0 ? templateSelectedCategoryIds[0] : "";
			} else if (payload.hasOwnProperty("selectedCategory")) {
				const sc = payload.selectedCategory;
				if (sc != null && sc !== "") {
					templateSelectedCategory = sc;
					templateSelectedCategoryIds = [sc];
				} else {
					templateSelectedCategory = "";
					templateSelectedCategoryIds = [];
				}
			}

			this.setState({
				templateId,
				templateSelectedCategory,
				templateSelectedCategoryIds,
				templateSelectionMode: payload.templateMode != null ? payload.templateMode : this.state.templateSelectionMode,
				templateType: payload.templateType != null ? payload.templateType : this.state.templateType,
				selectedTemplateIds,
				selectedTemplates: nextTemplates
			}, () => {
				this.updateProgress();
			});
		} else {
			this.setState({ templateId: payload }, () => {
				this.updateProgress();
			});
		}
	}

	updateTraining = (payload) => {
		this.setState(
			(prev) => ({ training: { ...prev.training, ...payload } }),
			() => this.updateProgress()
		);
	}

	/** Called by the Training step's Configure Training modal once course settings
	    + email templates are done, to advance to the next step (Preview). */
	proceedFromTraining = () => {
		if (this.state.currentStep < this.getTotalSteps()) {
			const nextStep = this.state.currentStep + 1;
			this.setState(
				{ currentStep: nextStep, highestStepReached: Math.max(this.state.highestStepReached, nextStep) },
				() => this.updateProgress()
			);
		}
	}

	updatePreview = (data) => {
		this.setState({ previewData: data }, () => {
			this.updateProgress();
		});
	}

	renderStepContent = () => {
		const key = this.getStepKey(this.state.currentStep);
		switch (key) {
			case "simulationType":
				return (
					<SimulationTypeStep
						ref={ref => this.stepRefs.simulationType = ref}
						simulationType={this.state.simulationType}
						attackType={this.state.attackType}
						onUpdate={this.updateSimulationType}
						readOnly={false}
					/>
				);
			case "attackVector":
				return (
					<AttackVectorStep
						ref={ref => this.stepRefs.attackVector = ref}
						simulationType={this.state.simulationType}
						attackType={this.state.attackType}
						credentialHarvesting={this.state.credentialHarvesting}
						onUpdate={this.updateAttackVector}
						readOnly={this.props.prefilledFromTemplate}
					/>
				);
			case "campaignDetails":
				return (
					<CampaignDetailsStep
						ref={ref => this.stepRefs.campaignDetails = ref}
						simulationType={this.state.simulationType}
						attackType={this.state.attackType}
						campaignDetails={this.state.campaignDetails}
						userReplyFeature={this.state.userReplyFeature}
						credentialHarvesting={this.state.campaignDetails?.credentialHarvesting ?? this.props.credentialHarvesting}
						onUpdate={this.updateCampaignDetails}
						prefilledFromTemplate={this.props.prefilledFromTemplate}
						targetInteractionType={this.props.targetInteractionType}
						isAIbased={this.props.isAIbased}
					/>
				);
			case "templateSelection":
				return (
					<TemplateSelectionStep
						ref={ref => this.stepRefs.templateSelection = ref}
						templateId={this.state.templateId}
						campaignTemplateId={this.props.campaignTemplateId}
						selectedCategory={this.state.templateSelectedCategory}
						selectedCategoryIds={this.state.templateSelectedCategoryIds}
						selectedTemplateIds={this.state.selectedTemplateIds}
						templateMode={this.state.templateSelectionMode}
						templateType={this.state.templateType}
						simulationType={this.state.simulationType}
						attackType={this.state.attackType}
						credentialHarvesting={this.state.campaignDetails?.credentialHarvesting ?? this.props.credentialHarvesting}
						onUpdate={this.updateTemplateSelection}
						onPreviewTemplate={(templateId) => this.setState({ showTemplateDetailsModal: true, previewTemplateId: templateId })}
						readOnly={this.props.prefilledFromTemplate}
						campaignDetails={this.state.campaignDetails}

					/>
				);
			case "trainingSelection":
				return (
					<TrainingSelectionStep
						ref={ref => this.stepRefs.trainingSelection = ref}
						training={this.state.training}
						onUpdate={this.updateTraining}
						onProceed={this.proceedFromTraining}
					/>
				);
			case "preview":
				return (
					<PreviewStep
						ref={ref => this.stepRefs.preview = ref}
						allData={{
							simulationType: this.state.simulationType,
							attackType: this.state.attackType,
							credentialHarvesting: this.state.campaignDetails?.credentialHarvesting,
							campaignDetails: this.state.campaignDetails,
							templateId: this.state.templateId,
							templateSelectionMode: this.state.templateSelectionMode,
							selectedTemplates: this.state.selectedTemplates,
							training: this.state.training
						}}
						onUpdate={this.updatePreview}
					/>
				);
			default:
				return null;
		}
	}

	render() {
		const stepMeta = {
			simulationType: { title: "Simulation Type", description: "Select base simulation" },
			attackVector: { title: "Attack Vector", description: "Choose the attack method" },
			campaignDetails: { title: "Campaign Details", description: "Set up key campaign information" },
			templateSelection: { title: "Template Selection", description: "Select the attack template" },
			trainingSelection: { title: "Training Selection", description: "Select the training course" },
			preview: { title: "Preview", description: "Verify details before launch" }
		};
		const steps = this.getStepKeys().map((key, idx) => ({
			number: idx + 1,
			key,
			title: stepMeta[key].title,
			description: stepMeta[key].description
		}));
		const totalSteps = this.getTotalSteps();
		const currentKey = this.getStepKey(this.state.currentStep);

		return (
			<>
				<Modal
					show={this.props.showModal}
					onHide={() => this.props.showHandle()}
					className="campaign-creation-modal"
					dialogClassName="campaign-modal-dialog"
					size="xl"
					centered
				>
					<Modal.Header closeButton className="campaign-modal-header">
						<div className="campaign-modal-header-inner">
							<div className="campaign-modal-title">
								<h5 className="campaign-modal-title-text">Campaign Creation</h5>
								<div className="progress-indicator">
									<span>{this.state.progress}% Complete</span>
								</div>
							</div>
							<div className="campaign-modal-progress-bar">
								<div className="campaign-modal-progress-track">
									<div
										className="campaign-modal-progress-fill"
										style={{ width: `${this.state.progress}%` }}
									/>
								</div>
							</div>
						</div>
					</Modal.Header>
					<Modal.Body className="campaign-modal-body">
						<div className="campaign-modal-container">
							<div className="campaign-sidebar">
								{steps.map((step) => {
									const highestStepReached = this.state.highestStepReached ?? this.state.currentStep;
									const { simulationType, attackType, campaignDetails, templateId, selectedTemplateIds, currentStep } = this.state;
									const campaignDetailsFilled = !!(campaignDetails?.campaignName && campaignDetails?.targetGroups?.length > 0);
									const templateFilled = !!(templateId || (selectedTemplateIds && selectedTemplateIds.length > 0));
									const trainingFilled = !!(this.state.training?.selectedCourses?.length > 0);
									const stepHasData = (stepKey) => {
										if (stepKey === "simulationType") return !!simulationType;
										if (stepKey === "attackVector") return !!attackType;
										if (stepKey === "campaignDetails") return campaignDetailsFilled;
										if (stepKey === "templateSelection") return templateFilled;
										if (stepKey === "trainingSelection") return trainingFilled;
										if (stepKey === "preview") return currentStep >= totalSteps;
										return false;
									};
									const isCompleted = stepHasData(step.key);
									const isDisabled = step.number > highestStepReached;
									const isClickable = !isDisabled;
									return (
										<div
											key={step.number}
											className={`step-item ${this.state.currentStep === step.number ? 'active' : ''} ${isCompleted ? 'completed' : ''} ${isDisabled ? 'disabled' : ''}`}
											onClick={() => isClickable && this.handleStepChange(step.number)}
											style={isDisabled ? { pointerEvents: 'none', opacity: 0.6 } : { cursor: 'pointer' }}
										>
											<div className="step-number">
												{isCompleted ? (
													<PiCheckCircleFill className="step-completed-icon" />
												) : (
													<span className="step-number-circle">{step.number}</span>
												)}
											</div>
											<div className="step-content">
												<div className="step-title">{step.title}</div>
												<div className="step-description">
													{isCompleted ? 'Completed' : step.description}
												</div>
											</div>
										</div>
									);
								})}
							</div>
							<div className="campaign-main-content">
								{this.renderStepContent()}
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer className="campaign-modal-footer">
						{this.state.currentStep > 1 && (
							<Button variant="secondary" className="previous-button" onClick={this.handleBack}>
								Previous
							</Button>
						)}
						<Button
							variant="primary"
							onClick={this.handleNext}
							className="continue-button"
							disabled={
								(currentKey === "campaignDetails" && !this.isCampaignDetailsContinueEnabled()) ||
								(currentKey === "templateSelection" && !this.isTemplateContinueEnabled()) ||
								(currentKey === "trainingSelection" && !this.isTrainingContinueEnabled())
							}
						>
							{currentKey === "preview" ? (
								<>
									<PiPaperPlaneTilt className="run-campaign-icon" />
									Run Campaign
								</>
							) : (
								<>Continue <PiCaretRightBold /></>
							)}
						</Button>
					</Modal.Footer>
				</Modal>

				{currentKey === "preview" && this.state.showRunModeModal && (
					<Modal
						show={true}
						onHide={this.handleRunModeCancel}
						backdrop="static"
						className="campaign-run-mode-modal"
						dialogClassName="campaign-run-mode-dialog"
						centered
					>
						<div className="campaign-run-mode-header">
							<div className="campaign-run-mode-header-content">
								<h5 className="campaign-run-mode-title">Campaign Run Mode</h5>
								<p className="campaign-run-mode-subtitle">Select the preferred execution mode for this campaign</p>
							</div>
							<button type="button" className="campaign-run-mode-close" onClick={this.handleRunModeCancel} aria-label="Close">
								×
							</button>
						</div>
						<Modal.Body className="campaign-run-mode-body">
							<div
								className={`campaign-run-mode-option ${this.state.runMode === "immediately" ? "selected" : ""}`}
								onClick={() => this.setState({ runMode: "immediately" })}
							>
								<div className="campaign-run-mode-option-icon">
									<img src={runImm} alt="Run Immediately" />
								</div>
								<div className="campaign-run-mode-option-content">
									<h6 className="campaign-run-mode-option-title">Run Immediately</h6>
									<p className="campaign-run-mode-option-desc">Begin the campaign right away</p>
								</div>
								<Form.Check
									type="radio"
									name="runMode"
									checked={this.state.runMode === "immediately"}
									onChange={() => this.setState({ runMode: "immediately" })}
									onClick={(e) => e.stopPropagation()}
								/>
							</div>
							<div
								className={`campaign-run-mode-option ${this.state.runMode === "test" ? "selected" : ""}`}
								onClick={() => this.setState({ runMode: "test" })}
							>
								<div className="campaign-run-mode-option-icon">
									<img src={runtest} alt="Run as Test Campaign" />
								</div>
								<div className="campaign-run-mode-option-content">
									<h6 className="campaign-run-mode-option-title">Run as Test Campaign</h6>
									<p className="campaign-run-mode-option-desc">Test the campaign without recording analytics</p>
								</div>
								<Form.Check
									type="radio"
									name="runMode"
									checked={this.state.runMode === "test"}
									onChange={() => this.setState({ runMode: "test" })}
									onClick={(e) => e.stopPropagation()}
								/>
							</div>
							<div
								className={`campaign-run-mode-option campaign-run-mode-option-schedule ${this.state.runMode === "schedule" ? "selected" : ""} ${this.state.runMode === "schedule" ? "has-datetime" : ""}`}
								onClick={() => this.setState({ runMode: "schedule" })}
							>
								<div className="campaign-run-mode-option-row">
									<div className="campaign-run-mode-option-icon">
										<img src={runSchedule} alt="Schedule for Later" />
									</div>
									<div className="campaign-run-mode-option-content">
										<h6 className="campaign-run-mode-option-title">Schedule for Later</h6>
										<p className="campaign-run-mode-option-desc">Set a specific date and time for the campaign to start</p>
									</div>
									<Form.Check
										type="radio"
										name="runMode"
										checked={this.state.runMode === "schedule"}
										onChange={() => this.setState({ runMode: "schedule" })}
										onClick={(e) => e.stopPropagation()}
									/>
								</div>
								{this.state.runMode === "schedule" && (
									<div
										className="campaign-run-mode-schedule-picker-inline campaign-run-mode-schedule-picker-inline--datepicker"
										onClick={(e) => e.stopPropagation()}
									>
										{/* <label className="campaign-run-mode-datepicker-label" htmlFor="campaign-scheduled-start">
											Scheduled start
										</label> */}
										<div className="campaign-run-mode-datepicker-input-shell">
											<DatePicker
												id="campaign-scheduled-start"
												selected={this.state.scheduledDate}
												onChange={(date) =>
													this.setState({ scheduledDate: date })
												}
												minDate={new Date()}
												showTimeInput
												timeInputLabel="Time"
												dateFormat="MM/dd/yyyy h:mm aa"
												customInput={<CampaignScheduleDateInput />}
												calendarClassName="campaign-run-mode-datepicker-calendar"
												popperClassName="campaign-run-mode-datepicker-popper"
												popperPlacement="top-start"
												popperModifiers={{
													offset: {
														enabled: true,
														offset: "0, 10",
													},
												}}
											/>
										</div>
									</div>
								)}
							</div>
						</Modal.Body>
						<div className="campaign-run-mode-footer">
							<Button variant="secondary" className="previous-button" onClick={this.handleRunModeCancel} >
								Cancel
							</Button>
							<Button variant="primary" onClick={this.handleRunModeSubmit} className="continue-button">
								Run Campaign
							</Button>
						</div>
					</Modal>
				)}
				{this.state.showTemplateDetailsModal && this.state.previewTemplateId && (
					<CampaignPreview
						show={this.state.showTemplateDetailsModal}
						campaignTemplateId={this.state.previewTemplateId}
						campaignType={this.state.templateType === "System Templates" ? "System Templates" : "My Templates"}
						keyType={this.state.templateType === "System Templates" ? "system" : "templates"}
						fromCampaign={true}
						dimCredentialHarvestingSections={true}
						credentialHarvestingOverride={this.state.campaignDetails?.credentialHarvesting}
						handleModal={() => this.setState({ showTemplateDetailsModal: false, previewTemplateId: null })}
						nextPath={() => { }}
						load={() => { }}
					/>
				)}
				{this.state.loading && <Loader />}
			</>
		);
	}
}

export default withRouter(LaunchNewModal);
